<template>
    <v-app>
       <v-container>  
        <v-row no-gutters>
            <v-col cols="12">
                <v-form ref="form">
                  <v-card>               
                    <v-card-title class="subtitle-1">{{embeddedFormData.header}}</v-card-title>
                        <template v-for="selectedField in embeddedFormData.selectedFields">                                             
                                <v-card-text :key="'t' + selectedField.formNameDD">
                                    <span  class="font-weight-black">{{selectedField.sectionName}}</span>
                                <c_form_layout 
                                        :ref="selectedField.formNameDD"
                                        :selectedFields="selectedField.collection" 
                                        :numberOfColumns="embeddedFormData.numberOfColumns" 
                                        :formName="selectedField.sectionName"                           
                                    ></c_form_layout>
                                    </v-card-text>                   
                            </template>  
                             <v-row justify="center"  v-show="loaded" no-gutters>
                                 <vue-recaptcha ref="recaptcha" 
                                        @verify="onVerify"
                                        :sitekey="siteKey">                                    
                                </vue-recaptcha>     
                             </v-row>
                             <v-row no-gutters class="mt-4" justify="center" v-show="loaded">
                                 <v-btn color="primary" depressed class="mr-4" @click="submit()" :disabled="robot">{{ $t("labels.Submit") }}</v-btn>
                             </v-row>                            
                                               
                          <v-card-actions>
                          <v-spacer></v-spacer>             
                            
                        </v-card-actions>                        
                         <v-row no-gutters>
                            <v-card-subtitle><span class="mt-2">{{embeddedFormData.footer}}</span></v-card-subtitle>
                         </v-row>                        
                       
                   </v-card> 
               </v-form>
            </v-col>              
        </v-row>   
        <v-dialog v-model="showErrorAlert" width="500">             
                <v-card-title class="headline grey lighten-2">
                {{$t('labels.CLI_ApplicationError')}}
                </v-card-title>
                <v-card-text class="grey lighten-2">
                    {{errorMessage}}
                </v-card-text>                  
                <v-divider></v-divider>
                <v-card-actions class="grey lighten-2">
                  <v-spacer></v-spacer>
                    <v-btn dark color="primary" @click="showErrorAlert = false">{{$t('labels.CLI_Close')}}</v-btn>
                  </v-card-actions>
            </v-dialog> 
            <v-dialog v-model="showSuccessAlert" width="500">             
                <v-card-title class="headline grey lighten-2">
                {{$t('labels.Success')}}
                </v-card-title>
                <v-card-text class="grey lighten-2">
                    {{successMessage}}
                </v-card-text>                  
                <v-divider></v-divider>
                <v-card-actions class="grey lighten-2">
                  <v-spacer></v-spacer>
                    <v-btn dark color="primary" @click="onSuccessClose()">{{$t('labels.CLI_Close')}}</v-btn>
                  </v-card-actions>
            </v-dialog>   
       </v-container>
        <div class="loading" v-if="loadFlag">Loading&#8230;</div> 
    </v-app>
</template>
<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import { EventBus } from "@/services/eventBus";
import uiSvc from "@/services/uiService";
import domainHelper from "@/services/domainHelper";
import c_form_layout from "./form-layout"
import { VueRecaptcha } from 'vue-recaptcha';
export default {
    components:{c_form_layout, 'vue-recaptcha': VueRecaptcha},
    data(){
        return {
            loadFlag:false,
            loaded:false,
            token: this.$route.params.token,
            showErrorAlert:false,
            showSuccessAlert:false,
            errorMessage:"",
            robot:true,
            captchaToken:"",
            siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
            successMessage: this.$t('messages.LD_SuccessMessage'),
            embeddedFormData:{
                formId:"",
                formName:"",
                numberOfColumns:1,
                header:"",
                footer:"",
                activeFlag:true,
                selectedFields:[]               
            },
        }
    },
    computed:{  
          
    },
    mounted(){      
      this.loadPage()
    },
    methods:{
          onVerify: function (response) {           
            if (response) 
               this.robot = false;
               this.captchaToken = response;
          },
        validate(errorMessage){
           this.$refs.form.validate();
           this.errorMessage =  errorMessage;
           this.showErrorAlert = true;
        },
        alertError(errorMessage){
             this.errorMessage =  errorMessage;
             this.showErrorAlert = true;
        },
        submit(){           
           if(!this.$refs.form.validate()){
             this.errorMessage = this.$t('errors.FillRequiredFields')
             this.showErrorAlert = true;
             return;
           }    
           let $this = this;
           this.embeddedFormData.selectedFields.forEach(s=>{                
                var collection = $this.$refs[s.formNameDD][0].getControls();
                s.collection = collection                
           });

           let postData = {
                 detail: this.embeddedFormData,
                 token: this.token,
                 captchaToken:this.captchaToken
              }
           this.loadFlag = true;
           dataSvc.getHttp()
          .post(domainHelper.getAPIHost() + "/v1/leadopportunities/embedded-forms/create-lead", postData)
          .then((res) => {    
           this.loadFlag = false;          
          if (res.data.ReturnStatus.ReturnCode == 200) {
              this.loadFlag = false;
              if(res.data.successMessage){
                this.successMessage = res.data.successMessage;
              }
              this.showSuccessAlert = true;                
          } 
          else if(res.data.ReturnStatus.ReturnCode == 422){
              this.validate(this.$t("errors." + res.data.ReturnStatus.ReturnMessage));
          }  
          else {      
              this.loadFlag = false;
              this.alertError(this.$t("errors." + res.data.ReturnStatus.ReturnMessage));
            
          }            
          this.loadFlag = false;  
      })
      .catch((err) => {
        this.loadFlag = false;           
        this.alertError(err);
      });

        },
        onlyUnique(value, index, self) {
           return self.indexOf(value) === index;
        },  
        getSelectedFields(formType){
            var selected =  this.embeddedFormData.selectedFields.filter(x=>x.formNameDD === formType);
            if(selected.length > 0)
                return JSON.parse(JSON.stringify({ controls: selected[0].collection}))  ;
            else
               return  {controls:[]};
        }, 
        getFormNameDisplay(val) {      
           var selected = this.getSelectedSection(val);         
           return selected.sectionName;       
        },   
         getSelectedSection(formType){
            let selectedArray =  this.embeddedFormData.selectedFields.filter(x=>x.formNameDD === formType); 
            let selected =  selectedArray[0];
            return selected;     
        },  
        onSuccessClose(){
            this.showSuccessAlert = false;
            this.$refs.form.resetValidation();
            this.loadForm();
        },   
       loadPage(){
        this.loadForm()
       },
       loadForm(){
         var postData = {
            token: this.token,
            lang: this.$route.query.lang
         }
         this.loadFlag = true;
         this.loaded = false;
         dataSvc.getHttp().post(domainHelper.getAPIHost() + "/v1/leadopportunities/embedded-forms/render-detail", postData).then((res) => {              
              this.loadFlag = false;
              this.loaded = true;
            if (res.data.ReturnStatus.ReturnCode == 200) {
                this.$refs.form.reset()
                this.embeddedFormData = res.data.detail; 
                                 
                      
            }              
            else {      
                this.loadFlag = false;
                this.errorMessage = this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
                this.showErrorAlert = true;
            }                                       
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.alertError(err);
        });
       }
    }
}
</script>
<style scoped>
 .subtitle-1{
   margin-bottom: 20px !important;;
 }
  span.required:after,  label.required:after{   
     color: #d00;
     content: "*";
     margin-left: 5px;
     top: 3px;
  }
</style>